import React from "react";
import Login from "@components/organisms/Login/Login";
const LoginPage: React.FC = () => {
  return <Login />;
};
export default LoginPage;